import script from "./Pending.vue?vue&type=script&setup=true&lang=js"
export * from "./Pending.vue?vue&type=script&setup=true&lang=js"

import "./Pending.vue?vue&type=style&index=0&id=94b67bd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94b67bd6"]])

export default __exports__